export const FETCH_INTERVIEW_PAYMENT_STATUS_REQUESTED = 'FETCH_INTERVIEW_PAYMENT_STATUS_REQUESTED'
export const FETCH_INTERVIEW_PAYMENT_STATUS_SUCCEEDED = 'FETCH_INTERVIEW_PAYMENT_STATUS_SUCCEEDED' 
export const FETCH_INTERVIEW_PAYMENT_STATUS_FAILED = 'FETCH_INTERVIEW_PAYMENT_STATUS_FAILED'